import { useRouter } from 'next/router'
import PrivacyEn from './privacy.en.mdx'
import Privacy from './privacy.mdx'
import MdPage from '@components/app/md-page'

const PrivacyView = () => {
  const router = useRouter()
  return (
    <div className="container-sm pt-5">
      <MdPage>
        {
          router.locale === 'ja' ? <Privacy /> : <PrivacyEn />
        }
      </MdPage>
    </div>
  )
}

export default PrivacyView
